import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { Button, Drawer, Form, Input } from 'antd';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ChangePasswordService } from 'services/ChangePassword';
import { sessionClose } from 'store/reducers/authReducer';
import { passwordRule } from 'utils/forms/validationRules';

function ChangePasswordForm({ isActive, onClose, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const handleSubmit = async (values) => {
    const { old_password, new_password } = values;

    const payload = {
      user_id: user.id,
      old_password,
      new_password,
    };

    setLoading(true);

    try {
      const res = await ChangePasswordService.changePassword(payload);

      if (res) {
        setLoading(false);
        form.resetFields();
        onSuccess();
        dispatch(sessionClose());
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const formFields = [
    {
      name: 'old_password',
      label: 'Старый пароль',
      rules: [
        {
          required: true,
          message: 'Обязательное поле',
        },
      ],
      placeholder: 'Введите старый пароль',
    },
    {
      name: 'new_password',
      label: 'Новый пароль',
      rules: passwordRule,
      placeholder: 'Введите новый пароль',
    },
    {
      name: 'newPasswordConfirm',
      label: 'Новый пароль',
      dependencies: ['new_password'],
      rules: [
        {
          required: true,
          message: 'Обязательное поле',
        },
        {
          min: 8,
          message: 'Мин. 8 символов',
        },
        ({ getFieldValue }) => ({
          validator(_, value) {
            if (!value || getFieldValue('new_password') === value) {
              return Promise.resolve();
            }

            return Promise.reject(new Error('Пароли должны совпадать!'));
          },
        }),
      ],
      placeholder: 'Подтвердите новый пароль',
    },
  ];

  return (
    <Drawer
      title="Смена пароля"
      width="40%"
      onClose={onClose}
      visible={
        isActive |
        (user.password_old > 30 && !user.isSuperUser) |
        user.password_set_by_admin
      }
      getContainer={false}
    >
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="horizontal"
        labelCol={{
          span: LABEL_SPAN,
        }}
        wrapperCol={{ span: CONTENT_SPAN }}
        labelAlign="right"
      >
        {formFields.map(({ name, label, placeholder, rules, dependencies }) => (
          <Form.Item
            key={name}
            name={name}
            label={label}
            rules={rules}
            hasFeedback
            dependencies={dependencies}
          >
            <Input.Password
              placeholder={placeholder}
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
            />
          </Form.Item>
        ))}

        <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
          <Button type="primary" htmlType="submit" loading={loading}>
            Сохранить
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}

export { ChangePasswordForm };
